import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { SectionTitle } from '../../components';

const StepContainer = styled.div`
  display: ${({ active }) => (active ? 'block' : 'none')};
`;

export const Step = ({ bannerText, children, isCurrent = false }) => {
  return (
    <StepContainer active={isCurrent}>
      <SectionTitle text={bannerText} />
      {children}
    </StepContainer>
  );
};

Step.propTypes = {
  children: PropTypes.node,
  isCurrent: PropTypes.bool,
  bannerText: PropTypes.string,
};
